module.exports = __webpack_public_path__ + "static/media/xero.f25ae2f4.png";